<template>
  <el-card>
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/admin/' }">Admin</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/admin/users'}">Usuarios</el-breadcrumb-item>
    </el-breadcrumb>
    <br />
    <br />
    <br />
    <app-table-paginate
      v-if="tableShow"
      :routeEdit="routeEdit"
      :tableQuery="getListUser"
      :tableColumns="tableColumns"
      :limit="limit"
      :search="true"
    ></app-table-paginate>
    <br />
    <el-button type="primary" size="medium" @click="nuevoRegistro()">
      Añadir usuario
      <i class="el-icon-circle-plus-outline el-icon-right"></i>
    </el-button>
  </el-card>
</template>

<script>
import { mapGetters } from "vuex";
import ApiService from "@/common/api.service";
import tablaConPaginador from "@/components/_commons/tablaConPaginador";

export default {
  name: "Users",
  components: {
    "app-table-paginate": tablaConPaginador
  },
  created() {
    this.routeEdit = "/admin/users/edit/";
    this.getUsers();

    setTimeout(() => {
      this.$root.$on("delete", id => {
        this.eliminarRegistro(id);
      });
    }, 200);
  },
  beforeDestroy() {
    this.$root.$off("delete", id => {
        this.eliminarRegistro(id);
      });
  },
  data() {
    return {
      usersAPI: false,
      loading: true,
      tableColumns: [
        {
          prop: "id",
          label: "#Id"
        },
        {
          prop: "user",
          label: "Usuario"
        },
        {
          prop: "level",
          label: "Permiso"
        }
      ],
      searchQuery: "",
      routeEdit: null,
      deleterow: false,
      limit: 20,
      tableShow: false
    };
  },
  methods: {
    async getUsers() {
      ApiService.post("admin/users", {
        token: localStorage.getItem("token")
      }).then(response => {
        this.usersAPI = response.data;
        this.tableShow = true;
      });
    },
    async eliminarRegistro(id) {
      this.tableShow = false;

      ApiService.post("admin/delete-user", {
        token: localStorage.getItem("token"),
        id: id
      }).then(response => {
        this.deleterow = response.data;
        setTimeout(() => {
          if (this.deleterow == 1) {
            this.$message({
              type: "success",
              message: "Se ha eliminado correctamente"
            });

            this.getUsers();
            setTimeout(() => {
              this.tableShow = true;
            }, 100);
          } else {
            this.$message({
              type: "warning",
              message: this.deleterow
            });
          }
        }, 200);
      });
    },
    nuevoRegistro() {
      this.$router.push("/admin/users/new");
    }
  },
  computed: {
    getListUser() {
      return this.usersAPI;
    }
  }
};
</script>





// WEBPACK FOOTER //
// src/components/CloudAdmin/users.vue